<template>
	<div class="c-main-nav__faq">
		<h2>{{faq.title}}</h2>
		<ul class="c-main-nav__faq-list">
			<li
				v-for="(item, i) in faqArray"
				:key="i"
				class="c-main-nav__faq-item">
					<a
						:href="item.url"
						class="c-main-nav__faq-link">
						{{item.name}}
					</a>
			</li>
		</ul>
		<a v-if="faq.readMoreUrl && faq.readMoreText" :href="faq.readMoreUrl" class="c-button c-button--ghost c-button--noboxshadow c-button--icon c-main-nav__faq-button">
			<span class="c-button--right">{{faq.readMoreText}}</span>
			<v-icon name="icon-arrow-circle" size="m"></v-icon>
		</a>
	</div>
</template>

<script>
import VIcon from '../../../components/icon/VIcon.vue';

export default {
	name: 'VMainNavFaq',
	components: {
		VIcon
	},
	props: {
		faq: Object
	},
	data() {
		return {
			faqArray: (this.faq.position === 'bottom') ? this.faq.links.slice(0, 3) : this.faq.links
		}
	}
}
</script>
